import { render } from "./employees-index.vue?vue&type=template&id=228fd844&scoped=true"
import script from "./employees-index.vue?vue&type=script&lang=js"
export * from "./employees-index.vue?vue&type=script&lang=js"

import "./employees-index.vue?vue&type=style&index=0&id=228fd844&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228fd844"]])

export default __exports__